// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-command-palette > .v-overlay__content > .v-sheet {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
}
:where(.vuetify-styles) .v-command-palette--density-default .v-command-palette__input-container {
  padding-block: 8px;
  padding-inline: 16px;
}

:where(.vuetify-styles) .v-command-palette--density-comfortable .v-command-palette__input-container {
  padding-block: 4px;
  padding-inline: 12px;
}

:where(.vuetify-styles) .v-command-palette--density-compact .v-command-palette__input-container {
  padding-block: 0px;
  padding-inline: 8px;
}

:where(.vuetify-styles) .v-command-palette__content {
  overflow-y: auto;
}
:where(.vuetify-styles) .v-command-palette__no-data {
  opacity: 0.6;
  padding: 16px;
  text-align: center;
}
:where(.vuetify-styles) .v-command-palette__list .v-list-subheader {
  opacity: 0.7;
  -webkit-user-select: none;
          user-select: none;
}
:where(.vuetify-styles) .v-command-palette__list .v-divider {
  margin-block: 4px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/labs/VCommandPalette/VCommandPalette.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".v-command-palette > .v-overlay__content > .v-sheet {\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n}\n.v-command-palette--density-default .v-command-palette__input-container {\n  padding-block: 8px;\n  padding-inline: 16px;\n}\n\n.v-command-palette--density-comfortable .v-command-palette__input-container {\n  padding-block: 4px;\n  padding-inline: 12px;\n}\n\n.v-command-palette--density-compact .v-command-palette__input-container {\n  padding-block: 0px;\n  padding-inline: 8px;\n}\n\n.v-command-palette__content {\n  overflow-y: auto;\n}\n.v-command-palette__no-data {\n  opacity: 0.6;\n  padding: 16px;\n  text-align: center;\n}\n.v-command-palette__list .v-list-subheader {\n  opacity: 0.7;\n  user-select: none;\n}\n.v-command-palette__list .v-divider {\n  margin-block: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
